import {PEV} from "../../../common/utils";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchMembersMatchingConditionList} from "./service";
import {UserGroupActions} from "../model";
import {uniqBy} from "lodash";
import {patchExcludedMembers} from "../userGroupDetails/model";

const initialState = {
  membersMatchingConditionList: PEV({
    data: [],
    totalPages: 0,
    totalElements: 0,
  }),
  excludedMembers: [],
  columns: [],
};

const getMembersMatchingCondition = createAsyncThunk("memberInfoList/fetch", async (param) => {
  return await fetchMembersMatchingConditionList(param.page, param.size, param.condition);
});

const MembersMatchingConditionListSlice = createSlice({
  name: "membersMatchingConditionList",
  initialState,
  reducers: {
    setExcludedMembers: (state, action) => {
      state.excludedMembers = action.payload
    },
    addExcludedMembers: (state, action) => {
      state.excludedMembers = uniqBy(
        action.payload.concat(state.excludedMembers),
        "userId"
      )
    },
    removeExcludedMember: (state, action) => {
      state.excludedMembers = state.excludedMembers.filter((member) => member.userId !== action.payload)
    },
  },
  extraReducers: {
    [getMembersMatchingCondition.pending.type]: (state) => {
      state.membersMatchingConditionList = PEV({...state.membersMatchingConditionList}, "Fetching members");
    },
    [getMembersMatchingCondition.fulfilled.type]: (state, action) => {
      state.membersMatchingConditionList = PEV({
        data: action.payload.dataSource,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      });
      state.columns = action.payload.columns;
    },
    [getMembersMatchingCondition.rejected.type]: (state) => {
      state.membersMatchingConditionList = PEV({...state.membersMatchingConditionList}, null, "Error while fetching members");
    },
    [UserGroupActions.getUserGroupDetails.fulfilled.type]: (state, action) => {
      state.excludedMembers = action.payload.excludedMembers
    },
    [patchExcludedMembers.fulfilled.type]: (state, action) => {
      state.excludedMembers = action.payload.excludedMembers
    },
  },
});

export const MembersMatchingConditionListReducer = MembersMatchingConditionListSlice.reducer;
const {addExcludedMembers, removeExcludedMember, setExcludedMembers} = MembersMatchingConditionListSlice.actions;

export const MemberInfoListActions = {
  getMemberInfoList: getMembersMatchingCondition,
  addExcludedMembers,
  removeExcludedMember,
  setExcludedMembers
};
